import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkLoginStatus = () => {
      const userStored = localStorage.getItem("user");
      if (userStored) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    };

    checkLoginStatus();
    window.addEventListener("storage", checkLoginStatus);
    window.addEventListener("login-change", checkLoginStatus);

    return () => {
      window.removeEventListener("storage", checkLoginStatus);
      window.removeEventListener("login-change", checkLoginStatus);
    };
  }, []);

  const handleActionClick = () => {
    if (isLoggedIn) {
      navigate("/course/basic");
    } else {
      navigate("/auth/login");
    }
  };

  return (
    <>
      <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
                .hero-container * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Poppins', sans-serif; }
                
                .hero-section {
                    position: relative;
                    height: 60vh; 
                    width: 100%;
                    display: flex;
                    justify-content: flex-start; 
                    align-items: center;
                    text-align: left; 
                    background-color: #FFF0F0; 
                    
                    background-image: url('/bg-merah.png');
                    background-size: cover;
                    background-position: right top; 
                    background-repeat: no-repeat;
                    
                    overflow: hidden; 
                }
                
                .content-wrapper { 
                    position: relative; 
                    z-index: 2; 
                    color: #333333; 
                    padding: 0 5%; 
                    max-width: 80%; /* Ditambah agar muat 1 baris */
                }
                
                .hero-image-overlay {
                    position: absolute;
                    right: 8%;     
                    bottom: 0;     
                    height: 100%;   
                    width: auto;   
                    z-index: 1;    
                    object-fit: contain;
                }
                
                .main-title { 
                    font-size: 2.2rem; /* Dikecilkan sedikit agar pas 1 baris */
                    font-weight: 700; 
                    margin-bottom: 10px; 
                    line-height: 1.2; 
                    letter-spacing: -0.5px;
                    color: #000000;
                    white-space: nowrap; /* Memaksa teks jadi 1 baris */
                }
                
                .text-red { color: #ff0000; font-weight: 700; }
                
                .subtitle { 
                    font-size: 1.05rem; 
                    font-weight: 400; 
                    margin-bottom: 30px; 
                    line-height: 1.5; 
                    color: #333333; 
                }
                
                .btn-action {
                    background-color: #ff0000;
                    color: white; 
                    border: none; 
                    padding: 12px 35px; 
                    font-size: 1rem; 
                    font-weight: 600; 
                    border-radius: 10px; 
                    cursor: pointer;
                    transition: all 0.3s ease; 
                    outline: none; 
                    box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);
                }
                
                .btn-action:hover { 
                    background-color: #cc0000;
                    transform: translateY(-2px); 
                }
                
                @media (max-width: 1100px) {
                    .main-title { font-size: 1.8rem; } /* Penyesuaian saat layar mulai mengecil */
                }

                @media (max-width: 768px) {
                    .hero-section { 
                        height: auto; 
                        padding: 60px 0;
                        flex-direction: column; 
                        background-image: none; 
                        background-color: #FFF0F0;
                    }
                    
                    .hero-image-overlay {
                        display: none; 
                    }
                    
                    .content-wrapper { 
                        max-width: 100%; 
                        padding: 0 20px; 
                        text-align: center; 
                    }

                    .main-title { font-size: 1.6rem; white-space: normal; } /* Kembali ke normal di HP agar tidak terpotong */
                    .subtitle { font-size: 0.95rem; }
                    .btn-action { width: 100%; }
                }
            `}</style>

      <div className="hero-container">
        <section className="hero-section">
          <div className="content-wrapper">
            <h1 className="main-title">
              Found The Program That <span className="text-red">Fits You?</span>
            </h1>

            <p className="subtitle">
              Take The Next Step And Start Learning With Fluenesia.
            </p>

            {!isLoggedIn ? (
              <button
                id="actionBtn"
                className="btn-action"
                onClick={handleActionClick}
              >
                {isLoggedIn ? "Start Learning Today!" : "Get Started"}
              </button>
            ) : (
              <a
                href="https://api.whatsapp.com/send/?phone=6282324433012&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn-action">Start Learning Today!</button>
              </a>
            )}
          </div>

          <img
            src="/aksi-login-simple.png"
            alt="Learning Indonesian"
            className="hero-image-overlay"
          />
        </section>
      </div>
    </>
  );
};

export default HeroSection;
